import Icon from "@mui/icons-material/Feedback";

export default function TranscriptIcon(props) {
	return <Icon color={props.color} />;
}
